import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="bg-white px-4 py-5 sm:px-6" aria-labelledby="testimonials-heading" data-id="element-158" data-mp="3kqw54mwtl6h6">
      <div className="mb-3 text-center" data-id="element-159" data-mp="3fycoti6qzx8o">
        <h2 id="testimonials-heading" className="mb-0.5 text-xl font-extrabold uppercase leading-tight text-brand-navy sm:text-3xl" data-id="element-160" data-mp="3fxb6csnek8gx">
          What Coaches Are Saying
        </h2>
        <p className="text-[11px] font-extrabold uppercase tracking-wide text-brand-teal sm:text-xs" data-id="element-161" data-mp="31zwcnbq49ej5">
          Verified reviews from pickleball coaches &amp; instructors
        </p>
      </div>
      <div className="space-y-2" data-id="element-162" data-mp="2s1q9yrwhk4d8">
        {testimonials.map(testimonial => <article key={testimonial.author} className="rounded-lg border border-brand-navy/10 bg-brand-cream p-3 shadow-sm" data-id="element-163" data-mp="2s3tba8339jx9">
            <div className="mb-1 flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-164" data-mp="qbeqn195u1d5">
              {Array.from({
            length: 5
          }, (_, index) => <StarIcon key={index} className="h-3 w-3 fill-brand-green text-brand-green" aria-hidden="true" data-id="element-165" data-mp="h8145e8mjyfq" />)}
            </div>
            <p className="mb-2 text-[11px] font-medium italic leading-snug text-brand-ink sm:text-xs" data-id="element-166" data-mp="c6ve5o6cmp9w">
              “{testimonial.text}”
            </p>
            <div className="flex items-center gap-2 border-t border-brand-navy/10 pt-2" data-id="element-167" data-mp="zwy2bt757b38">
              <span className="flex h-7 w-7 items-center justify-center rounded-full bg-brand-navy text-[11px] font-extrabold text-white" data-id="element-168" data-mp="14u7o8yvbp4mb">
                {testimonial.author.charAt(0)}
              </span>
              <div data-id="element-169" data-mp="v4emepkzg3v9">
                <p className="text-[11px] font-extrabold text-brand-navy" data-id="element-170" data-mp="v3mrzi34gc6k">
                  — {testimonial.author}
                </p>
                <p className="text-[9px] font-semibold uppercase tracking-wide text-brand-muted" data-id="element-171" data-mp="1nlqsta4zwqqg">
                  {testimonial.role} — {testimonial.location}
                </p>
              </div>
            </div>
          </article>)}
      </div>
    </section>;
}